export const safetyDataSheets = ( el ) => {

	const safetyDataSheetsLinkContainer = el.querySelector( '.js-safety-d-s-links' );
	const safetyDataSheetsLink = safetyDataSheetsLinkContainer.querySelectorAll( 'a' );

	// Make dynamic link open in new tab
	for ( let i = 0; i < safetyDataSheetsLink.length; i++ ) {
		 safetyDataSheetsLink[i].addEventListener( 'click', function( event ) {
			event.preventDefault();

			window.open( this.href, '_blank' );
		});
	 }
};

export default safetyDataSheets;
